import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    sideBar: {
        isOpen: true,
        reason: "user",
    },
};
const commonSlice = createSlice({
    name: "common",
    initialState,
    reducers: {
        setSideBarState(state, action) {
            state.sideBar = action.payload;
        },
    },
});
export default commonSlice.reducer;
export const { setSideBarState } = commonSlice.actions;
